module.exports = __webpack_public_path__ + "static/fretlink-offices-c748e08a0e9fbd0113224bcad41f4704.jpg";